import { render, staticRenderFns } from "./dateFromNow.vue?vue&type=template&id=4bfd6ea6"
import script from "./dateFromNow.vue?vue&type=script&lang=js"
export * from "./dateFromNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports